const template = `
<div class="vue_action-buttons">
    <button type="submit" class="ok-btn -width-full" id="find_submit" data-gtm-id="filter-button">{{ jsonval.dobutton }}</button>
    <span class="ok-btn btn-reset -width-full" @click="test">{{ jsonval.clearbutton }}</span>
</div>`


export default template



// WEBPACK FOOTER //
// ./src/components/templates/45/findbutton.js